import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PaperFillIcon, UploadIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
interface Props {
  onClickUpload?: () => void;
}
export const DropFile = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'> & Props>(({
  onClickUpload,
  className,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation(['build']);
  return <div ref={ref} onDragOver={e => {
    e.preventDefault();
  }} {...props} className={cn('flex flex-col items-center gap-2xs rounded-sm outline outline-[1px] outline-[#E9EAF2] bg-alternative px-lg py-md', className)}>
      <div className="flex flex-col items-center gap-3xs">
        <PaperFillIcon fill={ICON_COLOR.assistive} size={'sm'} />
        <div className={'text-center text-body-lg-semibold leading-[23px] text-assistive'}>
          {t('ai.fileDrag.description')}
        </div>
      </div>
      <Button rounded={'full'} size={'sm'} onClick={onClickUpload}>
        <UploadIcon size={'xs'} />
        {t('build.ai.fileUpload')}
      </Button>
    </div>;
});
DropFile.displayName = 'DropFile';